import { Edit, Hub } from '@mui/icons-material'
import SmartToyIcon from '@mui/icons-material/SmartToy';
import GoogleIcon from '@mui/icons-material/Google';
import XIcon from '@mui/icons-material/X';

export const general = [
    {
        appName: 'GPT 4.1',
        category: ['Official GPT Models'],
        avatar: <SmartToyIcon htmlColor='white'/>,
        description: 'Ask me anything!',
        entryMessage: `<p><strong>Hello!</strong> How can I assist you today?</p>`,
        initialPrompt: {
            role: "system",
            content: `**All your responses should be in HTML format.**`
        },
        route:'chat'
      },
      {
        appName: 'Claude Haiku 4.5',
        category: ['Official GPT Models'],
        description: "I'm great at writing!",
        avatar: <Edit htmlColor='white'/>,
        entryMessage: `<p><strong>Hello!</strong> How can I assist you today?</p>`,
        initialPrompt: {
            role: "system",
            content: `**All your responses should be in HTML format.**`
        },
        route:'claude-chat'
      },
      {
        appName: 'Gemini 3.5 Flash',
        category: ['Official GPT Models'],
        description: "Google's Chat Model",
        avatar: <GoogleIcon htmlColor='white'/>,
        entryMessage: `<p><strong>Hello!</strong> How can I assist you today?</p>`,
        initialPrompt: {
            role: "system",
            content: `**All your responses should be in HTML format.**`
        },
        route:'gemini-chat'
      },

      {
        appName: 'Grok 4',
        category: ['Official GPT Models'],
        description: 'Ask me anything!',
        avatar: <XIcon htmlColor='white'/>,
        entryMessage: `<p><strong>Hello!</strong> How can I assist you today?</p>`,
        initialPrompt: {
            role: "system",
            content: `**All your responses should be in HTML format.**`
        },
        route:'chat-grok'
      },
]